import loadable from "@loadable/component";
import { useQueryClient } from "@tanstack/react-query";
import { find } from "lodash";
import { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";

import { useGetOneFieldRequest } from "@krea/customer-features/store/field-requests/hooks/queries";
import { ONE_FIELD_REQUEST_STORE_KEY } from "@krea/customer-features/store/queryClient";
import { RESOURCE_TYPE } from "@krea/customer-features/utils";

const BankingData = loadable(
  () => import("@krea/customer-features/shared-components/banking-data"),
);

const GuarantorBankingData = ({ fieldRequestID, ssn, resourceId }) => {
  const queryClient = useQueryClient();
  const [currentGuarantor, setCurrentGuarantor] = useState(null);
  const { data: { submittedData } = {} } =
    useGetOneFieldRequest(fieldRequestID);

  useEffect(() => {
    setCurrentGuarantor(
      submittedData?.guarantors?.length > 0
        ? find(submittedData.guarantors, { ssn: ssn })
        : null,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submittedData]);

  return (
    <BankingData
      resourceId={resourceId}
      resourceType={RESOURCE_TYPE.GUARANTOR}
      onSuccess={async () => {
        await queryClient.invalidateQueries({
          queryKey: [ONE_FIELD_REQUEST_STORE_KEY, fieldRequestID],
        });
      }}
      className="ml-2"
      isOnboarded={currentGuarantor?.banking_data}
      isGuarantorsForm
      isPrivatePerson
    />
  );
};

export default withTranslation()(GuarantorBankingData);
